var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M9.734 21h-3.61C3.849 21 2 19.096 2 16.75v-8.5C2 5.904 3.848 4 6.125 4h3.609c.284 0 .516.24.516.531v1.771a.525.525 0 01-.516.531h-3.61c-.76 0-1.374.633-1.374 1.417v8.5c0 .784.614 1.417 1.375 1.417h3.609c.284 0 .516.239.516.53v1.772a.525.525 0 01-.516.531zM14.8 7.582l3.334 3.147H9.906c-.572 0-1.031.474-1.031 1.063v1.416c0 .59.46 1.063 1.03 1.063h8.229L14.8 17.418a1.09 1.09 0 00-.035 1.537l.941.97c.4.41 1.053.415 1.457.004l6.53-6.676a1.083 1.083 0 000-1.51l-6.526-6.667a1.009 1.009 0 00-1.456.004l-.941.97c-.417.425-.4 1.124.03 1.532z"
  }))));
}

export default SvgLogOut;